module.exports = __webpack_public_path__ + "img/interface OneB Studio_5 prew.38fa61c0.jpg";